import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';
import mapDispatch from '~/misc/mapDispatch';
import {push as changeURL} from 'react-router-redux';
import {getUserVerifyData, getUserW9form, uploadW9form, uploadInfo} from '~/modules/user/actions';
import AccountHeader from '../share/AccountHeader';
import Spinner from '~/components/common/Spinner';
import DotInfo from './component/dot-info';
import Upload from './component/upload';
import Status from './component/status';
import sharedCSS from '../share.css';
import css from './index.css'
import Button from '~/components/common/Button';
class BidVerify extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldUpdate: true,
      page:'',
      id: 0,
      token: '',
      isShowUploader: false
    }
  }
  componentWillMount() {
    this.updateUserInfo();
  }
  updateUserInfo = () => {
    this.props.updateUser().then(()=>{
      const { path } = this.props.user.w9form;
      const { w9formStatus: W9status,linkedStatus: linkStatus } = this.props.user.profileVerificate;
      const { verified_phone , emailVerified } = this.props.user;
      const queryString = path.replace(/^.+?\?/, '');
      const query = new URLSearchParams(queryString);
      const id = query.get('id');
      const token = query.get('token');
      const queryStatus = query.get('status');
      if(!verified_phone || !emailVerified) { 
        return this.setState({
          page: "NeedL1"
        })
      }
      if(linkStatus === "Linked" || W9status === "Verified") {
        return this.setState({
          page: "Success"
        })
      }else if(queryStatus === "NoDotMc") {
        return this.setState({
          page: "NotVerified"
        })
      }else if (queryStatus === "pending") {
        return this.setState({
          page: "Pending"
        })
      }else {
        this.setState({
          id,
          token
        })
        return this.props.getW9Info({
          id,
          token
        })
      }
      
    })
  }
  uploadImg = (file) => {
    const { id, token } = this.state;
    const { uploadImg } = this.props;
    return uploadImg({
      id,
      token,
      file,
    })
  }
  uploadInfo = (pics) => {
    const { id, token } = this.state;
    const { uploadInfo } = this.props;
    const { companyName, legalName, phone, mc, dot, authority } = this.props.user
    const files = {
      info: {
        companyName, legalName, phone, mc, dot, authority 
      },
      ...pics
    }
    return uploadInfo({
      id,
      token,
      files,
    }).then( ()=>this.updateUserInfo() )
  } 
  showUploader = () => {
    this.setState({
      isShowUploader: true
    })
  }
  gotoProfile = () => {
    const { isFree, goto } = this.props;
    isFree ? goto('/free-account') : goto('/my-account');
  }
  render () {
    const { loading, companyName, legalName, phone, mc, dot, authority } = this.props.user;
    const { page, isShowUploader }  = this.state;
    if (loading) {
      return (
        <div className={sharedCSS.viewH}>
          <div className={sharedCSS.spinnerLine}>
            <div className={sharedCSS.spinner}>
              <Spinner scalable={true}/>
            </div>
          </div>
        </div>
      );
    }
    if (page === "NeedL1") {
      return (
        <Status
          type="needL1"
        />
      )
    }
    if (page === "NotVerified") {
      return (
        <Status
          type="notverify"
        />
      )
    }
    if (page === "Pending") {
      return (
        <Status
          type="pending"
        />
      )
    }
    if (page === "Success") {
      return (
        <Status
          type="success"
        />
      )
    }
    return (
      <div>
        <AccountHeader
          tit="Carrier Verification"
          titleInfo="You'll be able to book loads upon verification."
        />
        <DotInfo info={({companyName, legalName, phone, mc, dot, authority})} />
        <div className={css.btnGroup}>
          <Button  mods={['large']} onClick={this.gotoProfile}>No, Go Edit</Button>
          <Button
            mods={['large', 'action']}
            onClick={this.showUploader}
          >Yes, It's Me</Button>
        </div>
        {
          isShowUploader && 
          <div>
            <div className={css.uploaderHr}></div>
            <Upload
              uploadImg = {this.uploadImg}
              uploadInfo = {this.uploadInfo}
            ></Upload>
          </div>
          
        }
      </div>
    );
  }
}

export default connect(({accountProfilePage, user, dots,account}) => {
  const { free, accountLevel} = account;
  const isFree = Number(accountLevel) <= Number(free)

  return {
    profileAccountInfo: accountProfilePage.profileAccountInfo,
    user,
    dots,
    isFree
  }
}
, mapDispatch({
  updateUser: ()=> getUserVerifyData(),
  getW9Info: (props ,{id, token})=>  getUserW9form(id, token),
  uploadImg: (props, {id, token, file}) => uploadW9form(id, token, file),
  uploadInfo: (props, {id, token, files}) => uploadInfo (id, token, files),
  goto: (props, url) =>  changeURL(url),
}))(BidVerify);


// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/BidVerfiy/index.js